export default "__VITE_ASSET__53nNfQHq__";